<div class="dialog-container p-6">
  <!-- Header -->
  <div class="flex items-center gap-4 mb-6">
    <div class="flex items-center justify-center w-12 h-12 rounded-full" 
         [ngClass]="{
           'bg-amber-100': severityClass === InactivitySeverity.WARNING,
           'bg-orange-100': severityClass === InactivitySeverity.URGENT,
           'bg-red-100': severityClass === InactivitySeverity.CRITICAL
         }">
      <mat-icon 
        [ngClass]="{
          'text-amber-600': severityClass === InactivitySeverity.WARNING,
          'text-orange-600': severityClass === InactivitySeverity.URGENT,
          'text-red-600': severityClass === InactivitySeverity.CRITICAL
        }">
        lock_clock
      </mat-icon>
    </div>
    <div class="flex-1">
      <h2 class="text-xl font-semibold m-0">Session Timeout</h2>
    </div>
  </div>

  <!-- Content -->
  <div class="dialog-content text-center">
    <div class="countdown-timer" [ngClass]="severityClass">
      {{ formattedTime }}
    </div>
    
    <p class="message">
      Your session will expire due to inactivity. Click "Continue" to stay logged in.
    </p>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <button 
      mat-button 
      (click)="onLogoutNow()">
      Logout Now
    </button>
    <button 
      mat-flat-button 
      color="primary"
      (click)="onStayLoggedIn()"
      cdkFocusInitial>
      Continue
    </button>
  </div>
</div>
